import Sentry from "@similarweb/sentry-logger";
import swLog from "@similarweb/sw-log";

import { DefaultFetchService } from "app/services/fetchService";

const fetchService = DefaultFetchService.getInstance();

const INVITE_TO_REGISTER_URL = "api/homepage/invitations/invite-to-register";
const REQUEST_ACCESS_URL = "api/homepage/invitations/invite/request-access";
const HIDE_INVITE_USERS_BANNER = "hideInviteUsersBanner";

export const inviteUsersToRegister = async (
    fullName: string,
    emails: string[],
    originalEmails: string[],
): Promise<string[]> => {
    try {
        const response = await fetchService.post(INVITE_TO_REGISTER_URL, {
            FullName: fullName,
            Emails: emails,
        });

        return Array.isArray(response) ? response : [];
    } catch (error) {
        Sentry.errorTracker({
            message: "[JOURNEY] - HomePage - inviteUsersToRegister Promise failed",
            e: error,
            level: "error",
            params: {
                extra: {
                    originalEmails,
                    distinctEmails: emails,
                },
            },
        });
        throw error;
    }
};

export const requestAccess = async (fullName: string, emails: string[], originalEmails: string[]): Promise<unknown> => {
    try {
        const response = await fetchService.post(REQUEST_ACCESS_URL, {
            Emails: emails,
        });
        await swLog.serverLogger(
            `[JOURNEY] - HomePage - requestAccess Promise success - ${fullName} - originalEmails: ${originalEmails} - distinctEmails: ${emails}`,
            null,
            "Info",
        );
        return response;
    } catch (error) {
        const logMsg = `[JOURNEY] - HomePage - requestAccess Promise failed - ${error} - originalEmails: ${originalEmails} - distinctEmails: ${emails}`;

        await swLog.serverLogger(logMsg, error, "Error");
        Sentry.errorTracker({
            message: "[JOURNEY] - HomePage - requestAccess Promise failed",
            e: error,
            level: "error",
            params: {
                extra: {
                    originalEmails,
                    distinctEmails: emails,
                },
            },
        });

        throw error;
    }
};

export const getLocalHideInviteUsersBanner = (): boolean => {
    return JSON.parse(localStorage.getItem(HIDE_INVITE_USERS_BANNER)) ?? false;
};

export const localHideInviteUsersBanner = (): void => {
    localStorage.setItem(HIDE_INVITE_USERS_BANNER, JSON.stringify(true));
};

export const getSessionHideInviteUsersBanner = (): boolean => {
    return JSON.parse(sessionStorage.getItem(HIDE_INVITE_USERS_BANNER)) ?? false;
};

export const sessionHideInviteUsersBanner = (): void => {
    sessionStorage.setItem(HIDE_INVITE_USERS_BANNER, JSON.stringify(true));
};
